import styled from 'styled-components';

/**
 * Contenedor principal del AspectRatio
 * Maneja el responsive design y los tamaños máximos
 */
export const AspectRatioContainer = styled.div`
  &.aspect-ratio {
    position: relative;
    width: 100%;
    /* max-width se maneja via inline styles en el componente */
    border-radius: 8px;
    overflow: hidden;
    
    /* Responsive para móviles */
    @media (max-width: 768px) {
      max-width: 100% !important; /* Forzar 100% en móviles */
    }
    
    /* Asegurar que el contenido mantenga el aspect ratio */
    > * {
      width: 100%;
      height: auto;
      display: block;
    }
    
    /* Para iframes específicamente */
    iframe {
      border: none;
      border-radius: 8px;
    }
    
    /* Para videos específicamente */
    video {
      border-radius: 8px;
    }
  }
`;
